// Mentions légales — page publique (indexable).

import SEOHead from "../SEOHead";
import { seoConfig, jsonLdBreadcrumb } from "../seoConfig";

const P = seoConfig.pages.mentionsLegales;

const H = ({ children }) => (
  <h2 className="mt-10 text-[15px] font-semibold uppercase tracking-widest text-[#111]">{children}</h2>
);
const Para = ({ children }) => (
  <p className="mt-3 text-[14px] text-[#6B7280] leading-relaxed">{children}</p>
);

const MentionsLegales = () => {
  return (
    <>
      <SEOHead
        title={P.title}
        description={P.description}
        keywords={P.keywords}
        path={P.path}
        jsonLd={jsonLdBreadcrumb([
          { name: "Accueil", path: "/" },
          { name: "Mentions légales", path: P.path },
        ])}
      />

      <section className="mx-auto max-w-3xl px-6 lg:px-10 pt-20 pb-24 lg:pt-28">
        <p className="text-[12px] font-semibold uppercase tracking-widest text-[#6B7280]">
          Informations légales
        </p>
        <h1 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-[-0.02em] text-[#111]">
          Mentions légales
        </h1>
        <p className="mt-4 text-[13.5px] text-[#6B7280]">Dernière mise à jour : février 2026.</p>

        <H>Éditeur du site</H>
        <Para>
          Le site <span className="text-[#111] font-medium">wyvio.app</span> et la plateforme
          <span className="text-[#111] font-medium"> WYVIO</span> sont édités et exploités par
          <span className="text-[#111] font-medium"> SimpliciCar Toulon Est</span>. WYVIO est
          la marque commerciale sous laquelle SimpliciCar Toulon Est distribue sa plateforme
          de suivi de la relation client à l&apos;ensemble des professionnels français.
          Toutes les communications SMS et emails émises depuis la plateforme WYVIO le sont pour
          le compte de SimpliciCar Toulon Est, responsable du traitement.
        </Para>
        <Para>
          Contact : <span className="text-[#111]">hello@wyvio.app</span>. Les coordonnées légales
          complètes (SIREN, RCS, siège social) sont communiquées sur simple demande à cette adresse.
        </Para>

        <H>Hébergement</H>
        <Para>
          Le site et les données de la plateforme sont hébergés au sein d'infrastructures
          cloud situées en Europe. L'hébergeur s'engage à respecter les standards
          en vigueur en matière de sécurité et de protection des données personnelles.
        </Para>

        <H>Propriété intellectuelle</H>
        <Para>
          L&apos;ensemble des contenus présents sur wyvio.app (textes, graphismes, logos,
          icônes, images, code source, marque WYVIO) est protégé par le droit d&apos;auteur
          et le droit des marques. Toute reproduction, représentation ou diffusion,
          totale ou partielle, sans autorisation écrite est strictement interdite.
        </Para>

        <H>Données personnelles</H>
        <Para>
          WYVIO traite les données personnelles conformément au Règlement Général
          sur la Protection des Données (RGPD). Les données confiées à la plateforme
          par une équipe utilisatrice appartiennent à cette équipe et à ses clients.
          Elles ne sont utilisées que pour la finalité opérationnelle de suivi des ventes.
        </Para>
        <Para>
          Toute personne dispose d'un droit d'accès, de rectification, d'effacement,
          de portabilité et d'opposition sur les données la concernant. Ces droits
          peuvent être exercés à l'adresse <span className="text-[#111]">hello@wyvio.app</span>.
        </Para>

        <H>Cookies</H>
        <Para>
          wyvio.app utilise uniquement les cookies strictement nécessaires au bon
          fonctionnement du service (authentification, sécurité) et, le cas échéant,
          des outils de mesure d'audience anonymisés destinés à améliorer l'expérience.
          Aucun cookie publicitaire n'est déposé.
        </Para>

        <H>Contact</H>
        <Para>
          Pour toute demande liée à ces mentions légales, écrivez-nous à
          <span className="text-[#111]"> hello@wyvio.app</span>.
        </Para>
      </section>
    </>
  );
};

export default MentionsLegales;
